(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlMaskedText', [])
        .directive('dynamicMaskedText', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-masked-text/custom-control-masked-text-template.html',
                controller: [
                '$scope', function ($scope) {
                    if ($scope.data && $scope.data.maskOptions && (typeof $scope.data.maskOptions === 'string')) {
                        $scope.data.maskOptions = $.parseJSON($scope.data.maskOptions);
                    }
                }]
            };
        });

    angular.module('CustomControlMaskedText')
       .directive('dynamicFilterMaskedText', ['$translate', function () {
           return {
               templateUrl: '/app/directives/custom-control-masked-text/custom-control-filter-masked-text-template.html',
               replace: true,
               restrict: 'E',
               controller: [
                   '$scope', function($scope) {
                       if ($scope.data && !$scope.data.fromComparison) {
                           $scope.data.fromComparison = 'EqualIgnoreCase';
                       }
                       if ($scope.data && $scope.data.maskOptions && (typeof $scope.data.maskOptions === 'string')) {
                           $scope.data.maskOptions = $.parseJSON($scope.data.maskOptions);
                       }
                   }
               ]
           };
       }]);
})();